<template>
  <div class="container">
    <ExternalQueryList
        headline="Emails"
        endpoint="/api/v2/emails"
        :endpoint-filters="{person_id: person.data.id}"
        :headlines="headlines"
        :filters="filters"
        :can-update="() => false"
        :show-checkboxes="false"
        :button-column-width="2"
        :page-size-options="null"
        @show="show"
    >
      <template v-slot:default="{ row: email }">
        <td class="text-center">
          <i v-if="email.attributes.attachments.length" class="fa fa-paperclip"></i>
        </td>

        <td class="ellipsis">
          <a href="#" @click.prevent="show(email)" v-tooltip="email.attributes.subject">
            {{ email.attributes.subject }}
          </a>
        </td>

        <td class="ellipsis">
          <span v-tooltip="email.attributes.from_address">
            {{ email.attributes.from_address }}
          </span>
        </td>

        <td class="ellipsis">
          <span v-tooltip="getToAddressesTooltip(email)">
            {{ getToAddresses(email) }}
          </span>
        </td>

        <td>
          <router-link :to="'/users/' + email.attributes.user_id">
            {{ email.attributes.user_full_name }}
          </router-link>
        </td>

        <td>
          {{ email.attributes.received_at | datetime }}
        </td>
      </template>

      <template #modals>
        <ShowModal :email="showing"/>
      </template>
    </ExternalQueryList>
  </div>
</template>

<script>
import ExternalQueryList from '../../../../../components/Panels/Lists/ExternalQuery.vue'
import ShowModal from "../../../../../components/EmailTracking/Emails/Modals/Show.vue";

export default {
  components: {ShowModal, ExternalQueryList},

  model: {
    prop: 'person',
    event: 'person-updated'
  },

  props: {
    person: {
      required: true
    }
  },

  data(){
    return {
      showing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 1, text: ''},
        {width: 6, text: 'Subject'},
        {width: 4, text: 'From'},
        {width: 4, text: 'To'},
        {width: 4, text: 'User'},
        {width: 4, text: 'Received At'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    show(email) {
      this.showing = email

      $('#show-email-modal').modal('show')
    },

    getToAddresses(email) {
      return this.getAllRecipients(email).join(', ')
    },

    getToAddressesTooltip(email) {
      return this.getAllRecipients(email).join('<br>')
    },

    getAllRecipients(email) {
      return email.attributes.to_addresses
          .concat(email.attributes.cc_addresses.map(address => 'CC: ' + address))
          .concat(email.attributes.bcc_addresses.map(address => 'BCC: ' + address))
    }
  }
}
</script>
